import * as React from 'react';
import {useField} from 'formik';

import {TextArea, TextAreaProps} from './TextArea';

type TextAreaFormikProps = {
    value?: string;
} & Omit<TextAreaProps, 'value'>;

export const TextAreaFormik = ({name, value = ``, ...props}: TextAreaFormikProps) => {
    const [field, meta] = useField(name);
    return (
        <TextArea
            {...props}
            {...field}
            error={meta.touched && meta.error}
        />
    );
};
